import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { auth, functions } from '../firebase';
import { observeWalletBalance } from '../services/transactionsService';
import { httpsCallable } from 'firebase/functions';

const Wallet = () => {
    const params = useParams();
    const navigate = useNavigate();
    const uid = params?.uid || auth.currentUser?.uid || null;

    const [balance, setBalance] = useState(0);
    const [upiId, setUpiId] = useState('');
    const [amount, setAmount] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const currentUid = auth.currentUser?.uid;
        if (currentUid && uid && currentUid !== uid) {
            navigate(`/wallet/${currentUid}`, { replace: true });
        }
    }, [uid, navigate]);

    useEffect(() => {
        if (!uid) return;
        const unsub = observeWalletBalance(uid, (b) => setBalance(Number(b || 0)));
        setSubscribed(true);
        return () => { if (unsub) unsub(); };
    }, [uid]);

    const handleWithdraw = async () => {
        setMessage('');
        const requestedAmount = Number(amount);
        if (!Number.isFinite(requestedAmount) || requestedAmount <= 0) {
            setMessage('Please enter a valid withdrawal amount');
            return;
        }
        if (!upiId || !upiId.includes('@')) {
            setMessage('Please enter a valid UPI ID');
            return;
        }
        if (requestedAmount > Number(balance || 0)) {
            setMessage('Withdrawal amount is greater than your available balance');
            return;
        }
        try {
            const createRequest = httpsCallable(functions, 'createWithdrawalRequest');
            await createRequest({ amount: requestedAmount, upiId: upiId.trim() });
            setAmount('');
            setUpiId('');
            setMessage('Withdrawal request submitted for admin confirmation.');
        } catch (error) {
            console.error('Withdrawal request failed:', error);
            setMessage(error?.message || 'Unable to submit withdrawal request');
        }
    };

    return (
        <div className="min-h-screen w-full bg-[#0e0e0e] text-white">
            <div className="mx-auto max-w-md px-5 pt-6 pb-10">
                <div className="flex items-center justify-between mb-6">
                    <div className="text-2xl font-semibold">Earnings</div>
                    <button onClick={() => navigate(-1)} className="px-3 py-1 rounded-full bg-white/10 hover:bg-white/20 transition">Back</button>
                </div>

                <div className="rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
                    <div className="text-white/80 text-sm mb-1">Total Tip Balance</div>
                    <div className="text-3xl font-extrabold">₹{Number(balance).toLocaleString('en-IN')}</div>
                    <div className="text-white/60 text-xs mt-1">Realtime {subscribed ? '✔' : ''}</div>
                </div>

                <div className="mt-6 rounded-2xl bg-white/5 ring-1 ring-white/10 p-5">
                    <div className="text-lg font-semibold mb-3">Withdraw</div>
                    <label className="block text-sm text-white/80 mb-2">Amount</label>
                    <input
                        type="number"
                        min="1"
                        max={Number(balance || 0)}
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="e.g. 500"
                        className="w-full bg-white/5 border border-white/10 rounded-lg p-3 text-white placeholder-white/40"
                    />
                    <label className="block text-sm text-white/80 mb-2 mt-4">UPI ID</label>
                    <input
                        value={upiId}
                        onChange={(e) => setUpiId(e.target.value)}
                        placeholder="e.g. username@upi"
                        className="w-full bg-white/5 border border-white/10 rounded-lg p-3 text-white placeholder-white/40"
                    />
                    <button
                        className="mt-4 w-full rounded-xl bg-gradient-to-br from-[#ff3b3b] to-[#ff0000] px-4 py-3 text-base font-semibold text-white shadow-[0_8px_30px_rgba(255,0,0,0.35)] ring-1 ring-red-500/30 active:scale-[0.99] transition"
                        onClick={handleWithdraw}
                    >
                        Withdraw to UPI
                    </button>
                    {!!message && <div className="mt-3 text-sm text-white/80">{message}</div>}
                </div>
            </div>
        </div>
    );
};

export default Wallet;

